import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'material-ui/styles';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';

import { COPPER_FILL_PERCENT_DECIMALS } from '../../../constants/globals';
import { Copper } from '../../../models';
import { getLengthUnit, inchToString } from '../../../lib/unitConversions';

const styles = function(theme){
  return {
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
    }
  }
}

export const CopperDetail = ({ classes, material, lengthUnit: unit }) => (
  <Paper className={classes.root}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Weight (oz)</TableCell>
          <TableCell>
            Thickness (
            {getLengthUnit(unit).symbol}
            )
          </TableCell>
          <TableCell>Copper Fill (%)</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{material.weight}</TableCell>
          <TableCell>{inchToString(material.thickness, unit, false)}</TableCell>
          <TableCell>
            {(material.copperFill * 100).toFixed(COPPER_FILL_PERCENT_DECIMALS)}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </Paper>
);

CopperDetail.propTypes = {
  classes:  PropTypes.shape({
    root: PropTypes.string
  }).isRequired,
  material: PropTypes.instanceOf(Copper).isRequired,
  lengthUnit: PropTypes.string.isRequired,
}

export default withStyles(styles)(CopperDetail);



// WEBPACK FOOTER //
// ./src/components/common/MaterialPanel/CopperDetail.js